import { useCallback } from 'react';
import { noop } from 'lodash';

import { useTranslation } from 'providers/GILT.provider';
import nullBind from 'utils/functions/nullBind.util';

import InputField from 'onboarding/common/InputField';

const validateUKPhone = (value) => {
  const ukRegex =
    // eslint-disable-next-line max-len,no-useless-escape
    /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/;
  return ukRegex.test(value);
};

const validatePhoneNumberSymbol = (value) => {
  const phoneSymbolsRegex = /^[0-9+)(\s]*$/;
  return phoneSymbolsRegex.test(value);
};

const PhoneNumberInput = ({ data, onPhoneNumberChange, onPhoneNumberValid = noop }) => {
  const { t } = useTranslation();

  const validateUsingRxp = useCallback(
    (onPhoneNumberValid, value) => {
      if (/^[0-9+)(\s]*$/.test(value)) {
        onPhoneNumberValid(true, value);
      }
      if (value.length !== 0 && !validateUKPhone(value)) {
        return t('common.errors.validation.notValidPhoneNumber');
      }
      return '';
    },
    [t],
  );

  return (
    <InputField
      data={data}
      onChangeHandler={onPhoneNumberChange}
      validateChange={nullBind(validatePhoneNumberSymbol, onPhoneNumberValid)}
      validateBlur={nullBind(validateUsingRxp, onPhoneNumberValid)}
    />
  );
};

export default PhoneNumberInput;
